import {
  Grid,
  Paper,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { IconButtonWithTooltip, PhoneNumberField } from 'components'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'

interface PhoneFaxSectionProps<T extends { areaCode: string | null, phoneNumber: string | null }> {
  phone: T | undefined
  fax: T | undefined
  disabled: boolean
  handlePhoneChange: (isFax: boolean, field: keyof T, value: string) => void
  handleAddPhone: (isPhoneType: boolean) => void
  handleDeletePhone: (isPhoneType: boolean) => void
}

export const PhoneFaxSection = <T extends { areaCode: string | null, phoneNumber: string | null }>({
  phone,
  fax,
  disabled,
  handlePhoneChange,
  handleAddPhone,
  handleDeletePhone
}: PhoneFaxSectionProps<T>): React.ReactElement => {
  return (
    <Paper elevation={1} sx={{ pb: 1, mb: 2, pt: 1, pr: 2 }}>
      <Grid container spacing={2} justifyContent={'flex-start'}>
        <Grid item xs={0.2}/>
        <Grid item xs={'auto'} display={'flex'} alignItems={'center'}>
          <Typography sx={{ fontWeight: 'bold' }} color={'primary'} noWrap>Phone:</Typography>
        </Grid>
        {phone != null
          ? (
            <>
              <Grid item xs={2}>
                <TextField
                  label="Area code"
                  variant="outlined"
                  disabled={disabled}
                  value={phone.areaCode}
                  onChange={(e) => { handlePhoneChange(false, 'areaCode', e.target.value) }}
                  inputProps={{ maxLength: 3 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs>
                <PhoneNumberField
                  label="Phone number"
                  phoneNumber={phone.phoneNumber}
                  handlePhoneChange={(value) => { handlePhoneChange(false, 'phoneNumber', value) }}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={'auto'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <IconButtonWithTooltip
                  label="Delete Phone"
                  color="primary"
                  disabled={disabled}
                  onClick={() => { handleDeletePhone(true) }}
                  icon={<DeleteIcon />}
                />
              </Grid>
            </>)
          : (
            <Grid item xs display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <IconButtonWithTooltip
                label="Add Phone"
                color="primary"
                disabled={disabled}
                onClick={() => { handleAddPhone(true) }}
                icon={<AddIcon />}
              />
            </Grid>
            )
        }

        <Grid item xs={'auto'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
          <Typography sx={{ fontWeight: 'bold' }} color={'primary'} noWrap>Fax:</Typography>
        </Grid>
        {fax != null
          ? (<>
            <Grid item xs={2}>
              <TextField
                label="Area code"
                variant="outlined"
                disabled={disabled}
                value={fax.areaCode}
                onChange={(e) => { handlePhoneChange(true, 'areaCode', e.target.value) }}
                inputProps={{ maxLength: 3 }}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <PhoneNumberField
                label="Fax number"
                phoneNumber={fax.phoneNumber}
                handlePhoneChange={(value) => { handlePhoneChange(true, 'phoneNumber', value) }}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={'auto'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <IconButtonWithTooltip
                label="Delete Fax"
                color="primary"
                disabled={disabled}
                onClick={() => { handleDeletePhone(false) }}
                icon={<DeleteIcon />}
              />
            </Grid>
          </>)
          : (
            <Grid item xs display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <IconButtonWithTooltip
                label="Add Fax"
                color="primary"
                disabled={disabled}
                onClick={() => { handleAddPhone(false) }}
                icon={<AddIcon />}
              />
            </Grid>
            )}
      </Grid>
    </Paper>
  )
}
